import { faBell } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Chip, Stack } from '@mui/material';
import React from 'react';

import { contractStatusMap } from '../../constants/contracts';

interface StatusChipProps {
  status: string;
  subStatus: string;
}

export default function StatusChip({ status, subStatus }: StatusChipProps): JSX.Element {
  const contractStatus = contractStatusMap[status];
  const contractColor = contractStatus && contractStatus[1];
  const contractLabel = (contractStatus && contractStatus[0]) || 'Unknown';

  const chipColor = (() => {
    if (contractColor === 'status-yellow') {
      return 'warning';
    }
    if (!contractStatus || contractColor === 'status-red' && subStatus !== 'On Track') {
      return 'error';
    }
    if (contractColor === 'status-black') {
      return 'default';
    }
    return 'primary';
  })();

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Chip
        color={chipColor}
        label={contractLabel}
        title={subStatus}
        sx={{
          minWidth: '90px',
        }}
        size="small"
      />
      {subStatus === 'Off Track' && (
        <FontAwesomeIcon data-testid="OrangeBellIcon" icon={faBell} color="rgba(230, 142, 0, 1)" />
      )}
    </Stack>
  );
}
